import React, { Component } from 'react';
import { connect } from 'react-redux';
import { actions } from '../../config/reduxIndex';
import NotesOverlay from '../../components/notes/NotesOverlay';

/**
 * Renders: {@link NotesOverlay}
 * @props {function} closeOverlay - redux -> closeNotesOverlay()
 * @returns NotesOverlay
 */
class NotesOverlayContainer extends Component {
	render() {
		const { closeOverlay } = this.props;
		return <NotesOverlay 
			closeOverlay = { closeOverlay }
		/>;
	}
}

const mapDispatchToProps = dispatch => {
	return {
		closeOverlay: () => {
			dispatch(actions.notes.closeNotesOverlay());
		}
	}
}

export default connect(null, mapDispatchToProps)(NotesOverlayContainer);


// WEBPACK FOOTER //
// ./src/containers/notes/NotesOverlayContainer.jsx